export const ELLIPSIS: unique symbol = Symbol('Ellipsis');

export type PaginationSlot = number | typeof ELLIPSIS;

type PaginationSlotsBuilder = {
  currentPage: number;
  totalPages: number;
};

const SLOTS_COUNT = 7;
const EDGE_PAGES_COUNT = 5;

const assertValid = ({ currentPage, totalPages }: PaginationSlotsBuilder) => {
  if (totalPages < 1) {
    throw new Error(`Total pages '${totalPages}' is lower than 1`);
  }
  if (currentPage < 1 || currentPage > totalPages) {
    throw new Error(`Current page '${currentPage}' is out of range [1, ${totalPages}]`);
  }
};

const range = (start: number, end: number): number[] =>
  Array.from({ length: end - start + 1 }, (_, index) => start + index);

export const paginationSlotsOf = ({
  currentPage,
  totalPages,
}: PaginationSlotsBuilder): PaginationSlot[] => {
  assertValid({ currentPage, totalPages });
  if (totalPages <= SLOTS_COUNT) {
    return range(1, totalPages);
  }
  if (currentPage < EDGE_PAGES_COUNT) {
    return [...range(1, EDGE_PAGES_COUNT), ELLIPSIS, totalPages];
  }
  if (currentPage > totalPages - EDGE_PAGES_COUNT + 1) {
    return [1, ELLIPSIS, ...range(totalPages - EDGE_PAGES_COUNT + 1, totalPages)];
  }
  return [1, ELLIPSIS, currentPage - 1, currentPage, currentPage + 1, ELLIPSIS, totalPages];
};
